import script from "./user-details.vue?vue&type=script&setup=true&lang=js"
export * from "./user-details.vue?vue&type=script&setup=true&lang=js"

import "./user-details.vue?vue&type=style&index=0&id=56615bbc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56615bbc"]])

export default __exports__